<template>


  <div v-if="column === 'status'">
    {{ item.status | statusLabel }}
  </div>
  <span v-else-if="formatter === null || formatter === undefined || formatter === ''" v-html="checkReplaceLine()"></span>
  <span v-else-if="formatter === 'money'" class="td-align-right">{{ getItemValue() | money }}</span>
  <span v-else-if="formatter === 'number'" class="td-align-right">{{ getItemValue() | number }}</span>
  <span v-else-if="formatter === 'boolean'">{{ getItemValue()  | yesOrNot }}</span>
  <span v-else-if="formatter === 'date'">{{ getItemValue()  | date }}</span>
  <span v-else-if="formatter === 'datetime'">{{ getItemValue()  | datetime }}</span>
  <span v-else-if="formatter === 'weightKg'">{{ getItemValue()  | weightKg }}</span>
  <span v-else-if="formatter.indexOf('lpad') > -1">{{ getItemValue() | lpad(4) }}</span>
  <span v-else-if="formatter === 'balance'" class="td-align-right" style="font-weight: bold;">

    <span v-if="getItemValue() > 0" style="color: #3230d4;">{{ getItemValue()  | number }}</span>
    <span v-else-if="getItemValue() < 0" style="color: #e00000">{{ getItemValue()  | number }}</span>
    <span v-else style="color: #000">{{ getItemValue()  | number }}</span>

  </span>
  <span v-else-if="formatter === 'color' &&  getItemValue() !== ''">
      <div class="mb-2 mr-2 badge badge-dot badge-dot-xl" :style="{'background-color': getItemValue()}">

      </div>
  </span>




</template>
<script>
export default {
  name: 't-table-field',
  data() {
    return {
    }
  },
  props: {
    column: {
      type: String,
    },
    formatter: {
      type: String,
      default: "",
    },
    label: { /*Quando utilizado significa que é um texto   fixo para formatação*/
      type: [String, Number],
      default: "",
    },
    item: {
      type: Object,
    },
  },
  methods: {

    checkReplaceLine(){

      let value = this.getItemValue()

      if(value !== null && value !== '' && value !== undefined && typeof value === 'string'){
        value = value.replace(/\n/g,'<br />')
      }

      return value


    },

    getItemValue() {



      if (this.label !== '' || this.label > 0) {

        return this.label

      } else {

        let item = this.item
        const key = this.column

        if (key.indexOf('field_') === 0) {
          /*Fieldcustom*/

          if (item.fieldsCustom && item.fieldsCustom[key]) {
            return item.fieldsCustom[key]
          } else {
            return ''
          }

        } else if (key.indexOf('.') > -1) {

          const obj = key.substring(0, key.indexOf("."))
          const attribute = key.substring(key.indexOf(".") + 1)

          if (item[obj] && item[obj][attribute]) {
            return item[obj][attribute]
          } else {
            return ''
          }

        } else {
          return item[key]
        }


      }


    }
  }
}
</script>